import { useAtomValue } from 'jotai';

import { userLanguageAtom } from 'common/state/localeState';

export const useUserLanguage = () => {
  return useAtomValue(userLanguageAtom);
};
